<div class="justify-content-center" style="padding: 1rem;">
  <p-toolbar>
    <div class="p-toolbar-group-start">
        <!-- <button pButton size="small" icon="pi pi-file-excel" label="Registros" class="mr-2"></button> -->
    </div>
    <div class="p-toolbar-group-center">
      <button pButton size="small" label="{{user.NombreReal}}" icon="pi pi-user" class="mr-2"></button>
      <!-- <button pButton size="small" label="Registros" icon="pi pi-file-excel" class="mr-2"></button> -->
      <button pButton size="small" label="Salir" icon="pi pi-sign-out" (click)="logout()"></button>
    </div>
    <div class="p-toolbar-group-end">
      <p-progressSpinner *ngIf="!webVersion" styleClass="w-2rem h-2rem" strokeWidth="6" animationDuration=".5s" />
      <p-tag *ngIf="webVersion" severity="success" value="versión {{webVersion}}"/>
    </div>
</p-toolbar>
</div>
<div class="card flex justify-content-center" style="padding: 1rem;">
  <div class="grid">
    <div class="col-12 md:col-4 lg:col-4">
      <app-devicelist (device)="updateTerminal($event)"></app-devicelist>
    </div>
    <div class="col-12 md:col-8 lg:col-8">
      <app-terminal *ngIf="!loadingHistory && !unselected" [chatHistory]="history" [selectedDevice]="device"
        (refreshMessages)="updateTerminal($event)"></app-terminal>
      <p-panel *ngIf="unselected || loadingHistory" header="Ventana de mensajes"
        [style]="{height: '300px'}">
        <p *ngIf="unselected"><span><i class="pi pi-angle-double-left"></i></span> Seleccione un equipo</p>
        <p *ngIf="loadingHistory">Cargando historial</p>
        <p-progressBar *ngIf="loadingHistory" mode="indeterminate" [style]="{ height: '6px' }" />
      </p-panel>
    </div>
  </div>
</div>
